module.exports = __webpack_public_path__ + "img/Path 27@3x.c20ee9a9.png";